import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContentSection, Heading, Primary } from "@cinch-labs/design-system";
import { StoryblokRenderer, renderWithResolver } from "@cinch-nx/landing-ui-shared";
import { useCookieModalOpen } from "@cinch-nx/shared-ui";
import { storyblokComponents } from "../../data/storyblok-renderer-map";
import styles from "./cookie-policy-section.module.css";
export var CookiePolicySection = function(param) {
    var title = param.title, intro = param.intro, content = param.content, buttonText = param.buttonText, tableSection = param.tableSection, deleteSection = param.deleteSection;
    var setIsPreferencesModalOpen = useCookieModalOpen().setIsPreferencesModalOpen;
    return /*#__PURE__*/ _jsxs("section", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                element: "h2",
                className: styles.title,
                fontSize: "h1",
                children: title
            }),
            /*#__PURE__*/ _jsx(ContentSection, {
                classNames: {
                    body: "storyblokRichTextBody"
                },
                children: renderWithResolver(intro)
            }),
            /*#__PURE__*/ _jsx(ContentSection, {
                children: /*#__PURE__*/ _jsx(Primary, {
                    type: "button",
                    name: buttonText,
                    value: buttonText,
                    onClick: function() {
                        return setIsPreferencesModalOpen(true);
                    },
                    children: buttonText
                })
            }),
            /*#__PURE__*/ _jsx(ContentSection, {
                classNames: {
                    body: "storyblokRichTextBody"
                },
                children: renderWithResolver(content)
            }),
            tableSection && /*#__PURE__*/ _jsx(StoryblokRenderer, {
                block: tableSection,
                components: storyblokComponents
            }),
            deleteSection && /*#__PURE__*/ _jsx(StoryblokRenderer, {
                block: deleteSection,
                components: storyblokComponents
            })
        ]
    });
};
export default CookiePolicySection;
